var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { padding: "0 10px" } },
    [
      _c(
        "b-form-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                { attrs: { label: "Enabled" } },
                [
                  _c("ExportSelect", {
                    staticClass: "form-control",
                    attrs: { options: _vm.isEnabledOptions },
                    model: {
                      value: _vm.isEnabled,
                      callback: function ($$v) {
                        _vm.isEnabled = $$v
                      },
                      expression: "isEnabled",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isEnabled
        ? _c(
            "div",
            [
              _c(
                "b-card",
                { attrs: { "bg-variant": "light" } },
                [
                  _c(
                    "b-form-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "10" } },
                        [
                          _c(
                            "b-form-group",
                            { attrs: { label: _vm.labelText } },
                            [
                              _c("b-form-input", {
                                attrs: { type: "number" },
                                on: { input: _vm.updateResultData },
                                model: {
                                  value: _vm.height,
                                  callback: function ($$v) {
                                    _vm.height = $$v
                                  },
                                  expression: "height",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "d-flex justify-content-center mt-1" },
                        [
                          _c(
                            "b-form-group",
                            { attrs: { label: "Color" } },
                            [
                              _c("ColorPicker", {
                                model: {
                                  value: _vm.backgroundColor,
                                  callback: function ($$v) {
                                    _vm.backgroundColor = $$v
                                  },
                                  expression: "backgroundColor",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-row",
                { staticClass: "mt-2" },
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Add text" } },
                        [
                          _c("ExportSelect", {
                            staticClass: "form-control",
                            attrs: { options: _vm.isEnabledOptions },
                            model: {
                              value: _vm.isTextEnabled,
                              callback: function ($$v) {
                                _vm.isTextEnabled = $$v
                              },
                              expression: "isTextEnabled",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.isTextEnabled
                ? _c(
                    "div",
                    [
                      _c(
                        "div",
                        [
                          _c("ExportPageEdgeText", {
                            on: {
                              "data-updated": function ($event) {
                                _vm.textToAdd = $event
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass:
                                "d-flex justify-content-end mt-3 mb-3",
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: { variant: "primary" },
                                  on: { click: _vm.addText },
                                },
                                [_vm._v("\n            Add\n          ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.texts, function (text, index) {
                        return _c(
                          "div",
                          { key: index },
                          [
                            _c("ExportPageEdgeText", {
                              attrs: { text: text },
                              on: {
                                "data-updated": function ($event) {
                                  return Object.assign(text, $event)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass:
                                  "d-flex justify-content-end mt-3 mb-3",
                              },
                              [
                                _c(
                                  "b-button",
                                  {
                                    attrs: { variant: "danger" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeText(index)
                                      },
                                    },
                                  },
                                  [_c("i", { staticClass: "fas fa-trash" })]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-form-row",
                { staticClass: "mt-2" },
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Add icon" } },
                        [
                          _c("ExportSelect", {
                            staticClass: "form-control",
                            attrs: { options: _vm.isEnabledOptions },
                            model: {
                              value: _vm.icon.isEnabled,
                              callback: function ($$v) {
                                _vm.$set(_vm.icon, "isEnabled", $$v)
                              },
                              expression: "icon.isEnabled",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.icon.isEnabled
                ? _c(
                    "div",
                    [
                      _c(
                        "b-card",
                        { attrs: { "bg-variant": "light" } },
                        [
                          _c(
                            "b-form-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: "Icon URL" } },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          type: "text",
                                          placeholder:
                                            "Absolute URL to the icon goes here...",
                                        },
                                        on: { input: _vm.updateResultData },
                                        model: {
                                          value: _vm.icon.url,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.icon, "url", $$v)
                                          },
                                          expression: "icon.url",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: "Icon Width" } },
                                    [
                                      _c("b-form-input", {
                                        attrs: { type: "number" },
                                        on: { input: _vm.updateResultData },
                                        model: {
                                          value: _vm.icon.width,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.icon, "width", $$v)
                                          },
                                          expression: "icon.width",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: "Icon Height" } },
                                    [
                                      _c("b-form-input", {
                                        attrs: { type: "number" },
                                        on: { input: _vm.updateResultData },
                                        model: {
                                          value: _vm.icon.height,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.icon, "height", $$v)
                                          },
                                          expression: "icon.height",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "Icon Horizontal position",
                                      },
                                    },
                                    [
                                      _c("ExportSelect", {
                                        staticClass: "form-control",
                                        attrs: {
                                          options:
                                            _vm.horizontalPositionOptions,
                                        },
                                        on: { change: _vm.updateResultData },
                                        model: {
                                          value: _vm.icon.horizontalPosition,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.icon,
                                              "horizontalPosition",
                                              $$v
                                            )
                                          },
                                          expression: "icon.horizontalPosition",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "Icon Vertical position",
                                      },
                                    },
                                    [
                                      _c("ExportSelect", {
                                        staticClass: "form-control",
                                        attrs: {
                                          options: _vm.verticalPositionOptions,
                                        },
                                        on: { change: _vm.updateResultData },
                                        model: {
                                          value: _vm.icon.verticalPosition,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.icon,
                                              "verticalPosition",
                                              $$v
                                            )
                                          },
                                          expression: "icon.verticalPosition",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "Icon Horizontal offset",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: { type: "number" },
                                        on: { input: _vm.updateResultData },
                                        model: {
                                          value: _vm.icon.horizontalOffset,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.icon,
                                              "horizontalOffset",
                                              $$v
                                            )
                                          },
                                          expression: "icon.horizontalOffset",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: { label: "Icon Vertical offset" },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: { type: "number" },
                                        on: { input: _vm.updateResultData },
                                        model: {
                                          value: _vm.icon.verticalOffset,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.icon,
                                              "verticalOffset",
                                              $$v
                                            )
                                          },
                                          expression: "icon.verticalOffset",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "6" } },
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: "Margin" } },
                                    [
                                      _c("b-form-input", {
                                        attrs: { type: "number" },
                                        on: { input: _vm.updateResultData },
                                        model: {
                                          value: _vm.icon.margin,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.icon, "margin", $$v)
                                          },
                                          expression: "icon.margin",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }